import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

jQuery(document).ready(() => {

    if (window.animationActivated) {
        iniSlide2();
        iniSlide3();
        iniSlide4();
    }


    let showMenu = true;

    const slide1Top = $('#slide1').offset().top-80;
    const slide2Top = $('#slide2').offset().top-80;
    let slide2Activated = false;
    const slide3Top = $('#slide3').offset().top-80;
    let slide3Activated = false;
    const slide4Top = $('#slide4').offset().top-80;
    let slide4Activated = false;
    const slide5Top = $('#slide5').offset().top-80;
    const slide6Top = $('#slide6').offset().top-80;

    $('body').scroll(function () {
        const scrollTop = $('body').scrollTop();
        if (scrollTop >= 250 && showMenu === true) {
            showMenu = false;
            $('.menu-main').animate({
                opacity: 0,
            }, 400);
        } else if (scrollTop < 250 && showMenu === false) {
            showMenu = true;
            $('.menu-main').animate({
                opacity: 1,
            }, 400);
        }

        if (scrollTop >= slide2Top && slide2Activated === false) {
            window.playSlide2();
            slide2Activated = true;
        }
        if (scrollTop >= slide3Top && slide3Activated === false) {
            window.playSlide3();
            slide3Activated = true;
        }
        if (scrollTop >= slide4Top && slide4Activated === false) {
            window.playSlide4();
            slide4Activated = true;
        }

        if (scrollTop >= slide1Top && scrollTop < slide2Top) {
            $('.home-sidebar li').removeClass('active text-white');
        } else if (scrollTop >= slide2Top && scrollTop < slide3Top) {
            $('.home-sidebar li').removeClass('active text-white');
            $('.home-sidebar .menu1').addClass('active');
        } else if (scrollTop >= slide3Top && scrollTop < slide4Top) {
            $('.home-sidebar li').removeClass('active text-white');
            $('.home-sidebar .menu2').addClass('active');
        } else if (scrollTop >= slide4Top && scrollTop < slide5Top) {
            $('.home-sidebar li').removeClass('active').addClass('text-white');
            $('.home-sidebar .menu3').addClass('active');
        } else if (scrollTop >= slide5Top && scrollTop < slide6Top) {
            $('.home-sidebar li').removeClass('active text-white');
            $('.home-sidebar .menu4').addClass('active');
        } else if (scrollTop >= slide6Top) {
            $('.home-sidebar li').removeClass('active text-white');
        }
    });
});

window.slideTo = function (id) {
    const height = document.querySelector('body').clientHeight;
    document.querySelector('body').scrollTo(0, height * id);
}

window.playSlide2 = function () {
    window.tlSlide2.play();
    console.log(window.tlSlide2);
}
window.playSlide3 = function () {
    window.tlSlide3.play();
}
window.playSlide4 = function () {
    window.tlSlide4.play();
}

var iniSlide2 = function () {
    const height_slide2 = $('#slide2').outerHeight();
    window.tlSlide2 = gsap.timeline({
        defaults: {
            duration: 1,
        },

    });
    window.tlSlide2
        .from('#slide2 .title', {
            ease: 'power3.out',
            x: '+=240',
            y: (height_slide2 / 2 - 80),
            duration: 1.5,
            cursor: 'pointer',
        })
        .from('#slide2', { paddingTop: 0, duration: 1.5 }, '-=2')
        .from('#slide2 .title p', {
            ease: 'power3.out',
            opacity: 0,
        })
        .from('#slide2 .number-statistics', {
            ease: 'power3.out',
            width: 0,
            minHeight: 0,
            opacity: 0,
            duration: 2,
        }, '-=0.3')
        .from('#slide2 .title h1', {
            ease: 'power3.out',
            maxWidth: 494,
        }, '-=3')
        .from('#slide2 .title .subtitle2', {
            ease: 'power3.out',
            fontSize: '3.6rem',
        }, '-=3')
        .from('#slide2 .title .subtitle3', {
            ease: 'power3.out',
            textTransform: 'uppercase',
            fontSize: '4rem',
            lineHeight: '48px',
        }, '-=3');
    window.tlSlide2.pause();
}

var iniSlide3 = function () {
    const height_slide3 = $('#slide3').outerHeight();
    window.tlSlide3 = gsap.timeline({
        defaults: {
            duration: 1,
        },
        onComplete: function () {
            $('#slide3 .circle .brand').hover(
                function () {
                    gsap.to('#slide3 .circle .brand', {opacity:0.8, duration: 0.4});
                    gsap.to($(this), { scale: 1.2, opacity:1, duration: 0.4 })
                },
                function () {
                    gsap.to('#slide3 .circle .brand', {opacity:1, duration: 0.4});
                    gsap.to($(this), { scale: 1, duration: 0.4 })
                }
            );
        },
    });
    window.tlSlide3
        .from('#slide3', { paddingTop: 0, duration: 0.2 })
        .from('#slide3 .title', {
            ease: 'power3.out',
            y: (height_slide3 / 2 - 70),
            duration: 2,
            maxWidth: '480px',
            cursor: 'pointer',
            zIndex: 100,
        })
        .from('#slide3 .subtitle1', {
            fontSize: '3.8rem',
            duration: 1,
        }, '-=2')
        .from('#slide3 .subtitle2', {
            fontSize: '4rem',
            textTransform: 'none',
            marginTop: '-10px',
            x: 168,
            duration: 1,
        }, '-=2')
        .from('#slide3 .subtitle3', {
            fontSize: '3.8rem',
            duration: 1,
        }, '-=2')
        .from('#slide3 .circle', {
            ease: 'power3.out',
            height: '-=40',
            width: '-=40',
            y: (height_slide3 / 2 - 400),
        }, '-=1')
        .from('#slide3 .circle .brand', {
            scale: 0.5,
            opacity: 0,
            stagger: 0.2,
            ease: 'elastic',
            duration: 2,
        })
        .from('#slide3 .circle p', {
            opacity: 0,
            duration: 1,
        }, '-=2')

    window.tlSlide3.pause();
}

var iniSlide4 = function () {
    window.tlSlide4 = gsap.timeline({
        defaults: {
            duration: 2,
        },
    });
    window.tlSlide4
        .from('#slide4 .title', {
            ease: 'power3.out',
            fontSize: '3.8rem',
            y: '+=123',
            duration: 2,
        })
        .from('#slide4 .bg-primary', {
            height: 504,
            position: 'initial',
        }, '-=2')
        .from('#slide4 img', {
            height: '100vh',
            opacity: 1,
            duration: 3,
        }, '-=2')
        .from('#slide4 .subtitle2', {
            display: 'block', duration: 0.2,
        }, '-=2')
        .from('#slide4 .subtitle4', {
            display: 'block', duration: 0.2,
        }, '-=2')
        .from('#slide4 .subtitle4', {
            ease: 'power3.out',
            fontSize: '4rem',
            x: 120,
            duration: 2,
        }, '-=2')
        .from('#slide4 p', {
            autoAlpha: 0,
            duration: 1,
        }, '-=1.5')
        .from('#slide4 a', {
            autoAlpha: 0,
            duration: 1,
        })


    window.tlSlide4.pause();
}






// WEBPACK FOOTER //
// ./scripts/pages/accueil.js